import vars from "../helpers";

const init = () => {
	const $leadership = vars.$document.find('.leadership');
	const $slider = document.querySelector('.leadership__slider');
	if ($leadership.length) {
		new Swiper($slider, {

			initialSlide: 0,
			slidesPerView: "auto",
			spaceBetween: 30,
			// centeredSlides: true,
			loop: true,
			slideToClickedSlide: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			on: {
				slideChangeTransitionStart: function () {
					$leadership.find('.leadership__main').removeClass('is-active');
				},
				slideChangeTransitionEnd: function () {
					let activeSlide = $('.swiper-slide-active');
					let image = activeSlide.find('img').attr('src');
					let title = activeSlide.find('.leadership__slider-title').text();
					let position = activeSlide.find('.leadership__slider-position').text();
					let text = activeSlide.find('.leadership__slider-text').text();


					setTimeout(() => {
						mainInfo(image, title, position, text);
						$leadership.find('.leadership__main').addClass('is-active');
					}, 100)
				},
			},

			breakpoints: {
				// when window width is >= 320px
				1: {
					slidesPerView: 1,
					spaceBetween: 0
				},
				1025: {
					initialSlide: 0,
					slidesPerView: "auto",
					spaceBetween: 30,
				}
			}
		});
	}

	function mainInfo(url, title, position, text) {
		$leadership.find('.leadership__image img').attr('src', url);
		$leadership.find('.leadership__title').text(title);
		$leadership.find('.leadership__position').text(position);
		$leadership.find('.leadership__text').text(text);
	}
};

export default {
	init,
}
